import BookingsCountLabel from 'components/Common/Labels/BookingsCountLabel'
import OfferLabels from 'components/Common/Labels/OfferLabels'
import ViewsCountLabel from 'components/Common/Labels/ViewsCountLabel'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import { OFFER_BOOKINGS_THRESHOLD } from 'constants/offer'
import React, { ComponentProps } from 'react'

type InheritedOfferLabelsProps = ComponentProps<typeof OfferLabels>

interface Props extends InheritedOfferLabelsProps {
  offer: App.Offer | App.OfferSummary
  showViewsLabel?: boolean
  showBadge?: boolean
}

function OfferPageLabelGroup(props: Props) {
  const {
    offer,
    showViewsLabel,
    showBadge,
  } = props

  const bookings = offer.stats.booked
  const showBookingsLabel = bookings >= OFFER_BOOKINGS_THRESHOLD
  return <LabelGroup>
    <OfferLabels offer={offer} />
    <BookingsCountLabel bookings={bookings} threshold="offer"/>
    {showViewsLabel && !showBookingsLabel && <ViewsCountLabel views={offer.stats.views} />}
    {showBadge && !!offer.badge && <OfferBadgeLabel badge={offer.badge} />}
  </LabelGroup>
}

export default OfferPageLabelGroup
